module.exports = __webpack_public_path__ + "img/saizi5.cb683f8e.png";